/* eslint-disble */
export const Mutations = {
}
